// AJAX Add to Cart with Toast Notification
document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');
  
  // Create toast notification element
  const createToast = () => {
    const toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.innerHTML = `
      <div class="toast-content">
        <span class="toast-icon">✓</span>
        <span class="toast-message">added to cart</span>
      </div>
    `;
    document.body.appendChild(toast);
    return toast;
  };
  
  forms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const button = form.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      
      button.textContent = 'adding...';
      button.disabled = true;
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        const data = await response.json();
        
        // Update cart count
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
        
        // Show toast notification
        const toast = createToast();
        setTimeout(() => {
          toast.classList.add('show');
        }, 10);
        
        // Remove toast after 2 seconds
        setTimeout(() => {
          toast.classList.remove('show');
          setTimeout(() => {
            toast.remove();
          }, 300);
        }, 2000);
        
        // Reset button
        button.textContent = 'added ✓';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
        
      } catch (error) {
        console.error('Error:', error);
        button.textContent = 'error - try again';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    });
  });
});